import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import SiteModeGate from "@/pages/SiteModeGate";
import Admin from "@/pages/Admin";
import Replays from "@/pages/Replays";
import AuthCallback from "@/pages/AuthCallback";
import EventHome from "@/pages/event/EventHome";
import CheckIn from "@/pages/event/CheckIn";
import CheckInSuccess from "@/pages/event/CheckInSuccess";
import Program from "@/pages/event/Program";
import Photos from "@/pages/event/Photos";
import More from "@/pages/event/More";
import EarlyAccess from "@/pages/event/EarlyAccess";
import Survey from "@/pages/event/Survey";
import VolunteerLogin from "@/pages/event/VolunteerLogin";
import VolunteerDashboard from "@/pages/event/VolunteerDashboard";
import GuestOfHost from "@/pages/event/GuestOfHost";
import EventDayHub from "@/pages/event/EventDayHub";
import Volunteer from "@/pages/Volunteer";
import SponsorProfile from "@/pages/event/SponsorProfile";
import SponsorList from "@/pages/event/SponsorList";
import Privacy from "@/pages/legal/Privacy";
import Terms from "@/pages/legal/Terms";
import PhotoRelease from "@/pages/legal/PhotoRelease";

function AppRouter() {
  const location = useLocation();
  // Detect session_id in URL fragment for OAuth callback - synchronous (before useEffect)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<SiteModeGate />} />
      <Route path="/pitches" element={<Home />} />
      <Route path="/sponsor" element={<Home />} />
      <Route path="/sponsorship" element={<Home />} />
      <Route path="/sponsors" element={<Home />} />
      <Route path="/volunteers" element={<Home />} />
      <Route path="/tickets" element={<Home />} />
      <Route path="/replays" element={<Replays />} />
      <Route path="/replay" element={<Replays />} />
      <Route path="/admin" element={<Admin />} />
      {/* 2026 Event Hub (mobile-first, additive) */}
      <Route path="/event" element={<EventHome />} />
      <Route path="/event/checkin" element={<CheckIn />} />
      <Route path="/event/checkin/success" element={<CheckInSuccess />} />
      <Route path="/event/program" element={<Program />} />
      <Route path="/event/photos" element={<Photos />} />
      <Route path="/event/more" element={<More />} />
      <Route path="/event/early-access" element={<EarlyAccess />} />
      <Route path="/event/survey" element={<Survey />} />
      <Route path="/event/volunteer-login" element={<VolunteerLogin />} />
      <Route path="/event/volunteer-dashboard" element={<VolunteerDashboard />} />
      {/* Group registration (Phase B) + Sponsor profiles (Phase F) */}
      <Route path="/event/guest-checkin" element={<GuestOfHost mode="checkin" />} />
      <Route path="/event/register-guest" element={<GuestOfHost mode="preregister" />} />
      <Route path="/event/day/:day" element={<EventDayHub />} />
      <Route path="/event/sponsors" element={<SponsorList />} />
      <Route path="/event/sponsor/:slug" element={<SponsorProfile />} />
      <Route path="/event/panel/:slug" element={<SponsorProfile />} />
      <Route path="/event/profile/:slug" element={<SponsorProfile />} />
      {/* General Freedom In Me volunteer form (not event-specific) */}
      <Route path="/volunteer" element={<Volunteer />} />
      {/* Legal / compliance pages (required for Twilio A2P 10DLC + email deliverability) */}
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/photo-release" element={<PhotoRelease />} />
      <Route path="/photo-opt-in" element={<PhotoRelease />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}
